import React from 'react';

import { useTheme } from '@mui/material/styles';

import SaveIcon from '@mui/icons-material/Save';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';

const SaveActionButton = (props: IBaseActionButtonProps) => {
  const theme = useTheme();
  return (
    <BaseActionButton
      styles={{
        color: theme.palette.success.main,
        '&:disabled': {
          color: theme.palette.grey[400],
        },
      }}
      {...props}>
      <SaveIcon />
    </BaseActionButton>
  );
};

export default SaveActionButton;
